import SupportPage from '@/docs-partials/resources/support.mdx';
import * as React from 'react';
export default {
  SupportPage,
  React
};